import { DirectiveOptions } from 'vue'
import { Tooltip } from "../../common/Tooltip";
import { DateTimeTooltip } from "../../common/DateTimeTooltip";

const TooltipDirective: DirectiveOptions = {
    inserted(el, node) {
        (el as any).tooltip = new Tooltip(el, node.value);
    },
    componentUpdated(el, node) {
        (el as any).tooltip.setProps(node.value);
    }
};

const TimeTooltipDirective: DirectiveOptions = {
    inserted(el, node) {
        new DateTimeTooltip(el, node.value)
    },
    componentUpdated(el, node) {
        (el as any).tooltip?.setDateTimeProps(node.value);
    }
};

export { TooltipDirective, TimeTooltipDirective};